// src/context/LanguageContext.js
import { createContext, useContext, useState } from "react";

const translations = {
  tr: {
    nav: { skills: "Teknolojiler", experience: "Deneyim", projects: "Projeler", certificates: "Sertifikalar", contact: "İletişim" },
    hero: { tag: "Frontend Manager & Developer", desc: "2020'dan bu yana web geliştirme alanında aktif olarak çalışıyorum. HTML, CSS, JavaScript ve React ile kullanıcı deneyimini ön planda tutan projeler üretiyorum.", cta1: "Projeleri Gör", cta2: "İletişime Geç" },
    stats: { years: "Yıl deneyim", projects: "Canlı proje", companies: "Şirket", certificates: "Sertifika" },
    sections: { skills: "Kullanılan Teknolojiler", experience: "Deneyim", projects: "Projeler", certificates: "Sertifikalar" },
    contact: { headline1: "BİRLİKTE", headline2: "ÇALIŞALIM", sub: "Yeni bir proje, freelance iş veya tam zamanlı fırsat için benimle iletişime geçin.", email: "E-posta", linkedin: "LinkedIn", github: "GitHub", instagram: "Instagram" },
    footer: { rights: "Frontend Manager & Developer" },
    admin: { login: "Giriş Yap", email: "E-posta", password: "Şifre", logout: "Çıkış", dashboard: "Panel", add: "Ekle", edit: "Düzenle", delete: "Sil", save: "Kaydet", cancel: "İptal", confirmDelete: "Silmek istediğinizden emin misiniz?", seedData: "Başlangıç Verisi Yükle", seedWarning: "Bu işlem örnek verilerle veritabanını dolduracak. Sadece bir kez çalıştırın." }
  },
  en: {
    nav: { skills: "Tech Stack", experience: "Experience", projects: "Projects", certificates: "Certificates", contact: "Contact" },
    hero: { tag: "Frontend Manager & Developer", desc: "I have been actively working in web development since 2020. I build projects prioritizing user experience with HTML, CSS, JavaScript and React.", cta1: "View Projects", cta2: "Get In Touch" },
    stats: { years: "Years exp.", projects: "Live projects", companies: "Companies", certificates: "Certificates" },
    sections: { skills: "Tech Stack", experience: "Experience", projects: "Projects", certificates: "Certificates" },
    contact: { headline1: "LET'S", headline2: "WORK TOGETHER", sub: "Get in touch for a new project, freelance work or full-time opportunity.", email: "Email", linkedin: "LinkedIn", github: "GitHub", instagram: "Instagram" },
    footer: { rights: "Frontend Manager & Developer" },
    admin: { login: "Login", email: "Email", password: "Password", logout: "Logout", dashboard: "Dashboard", add: "Add", edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel", confirmDelete: "Are you sure you want to delete?", seedData: "Load Seed Data", seedWarning: "This will populate the database with sample data. Run only once." }
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("tr");
  const t = translations[lang];
  const toggleLang = () => setLang(l => l === "tr" ? "en" : "tr");
  const getLang = (obj, field) => obj?.[`${field}_${lang}`] || obj?.[field] || "";
  return (
    <LanguageContext.Provider value={{ lang, t, toggleLang, getLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
